import {withProps} from 'recompose';
import omit from 'lodash/omit';

export default withProps(({fieldMetadata, hasPartsOnSite}) => ({
  fieldMetadata:
    hasPartsOnSite !== 'Yes'
      ? omit(fieldMetadata, ['PartsOnSiteDescription'])
      : fieldMetadata
}));



// WEBPACK FOOTER //
// ./src/tickets/hoc/partsOnSite.js